import axios from "axios";

export type GetBookingProductsReturn = {
    code: string,
    label: string
}[]

export const getBookingProducts =  async (req?: { tenants: string[], dealers: string[] }): Promise<GetBookingProductsReturn> => {
    const response = await axios.get('/booking/search/products', { params:{
        tenants: req?.tenants.join(',') || "",
        dealers: req?.dealers.join(',') || "",
    } });
    return response.data;
};
